import React from "react";
import { Tooltip, IconButton, TooltipProps, IconButtonProps, useTheme } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

interface InfoTooltipProps {
    title: TooltipProps["title"];
    icon?: React.ReactNode;
    buttonProps?: IconButtonProps;
    color?: string;
}

const InfoTooltip: React.FC<InfoTooltipProps> = ({
    title,
    icon,
    buttonProps,
    color
}) => {
    const theme = useTheme()
    return (
        <Tooltip title={title}>
            <IconButton
                size="small"
                sx={{ color: color ? color : (theme.palette as any).primary[700] }}
                {...buttonProps}
            >
                {icon ?? <FontAwesomeIcon icon={faInfoCircle} />}
            </IconButton>
        </Tooltip>
    );
};

export default InfoTooltip;
